// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  homeV2: {
    name: 'homeV2',
    componentName: 'HomeV2',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/HomeV2'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/HomeV2.js')).HomeV2
        : currentRouteName === 'homeV2'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.HomeV2 })))
    },
    path: '/:context?/gift-cards/p/:name?/:productLineId?/:configurationId?',
    channel: null
  },
  balance: {
    name: 'balance',
    componentName: 'Balance',
    chunk: () => import(
      /* webpackChunkName: "balance" */
      './pages/Balance'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Balance.js')).Balance
        : currentRouteName === 'balance'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Balance })))
    },
    path: '/:context?/gift-cards/balance',
    channel: null
  },
  list: {
    name: 'list',
    componentName: 'List',
    chunk: () => import(
      /* webpackChunkName: "list" */
      './pages/List'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/List.js')).List
        : currentRouteName === 'list'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.List })))
    },
    path: '/:context?/gift-cards/list',
    channel: null
  },
  thirdParty: {
    name: 'thirdParty',
    componentName: 'ThirdPartyList',
    chunk: () => import(
      /* webpackChunkName: "thirdParty" */
      './pages/ThirdPartyList'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ThirdPartyList.js')).ThirdPartyList
        : currentRouteName === 'specialty-cards'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ThirdPartyList })))
    },
    path: '/:context?/gift-cards/specialty-cards',
    channel: null
  },
});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
}